module.exports = __webpack_public_path__ + "img/inquire-img.cfa4a525.png";